export default __webpack_public_path__ + "static/media/about.b5b878b4.jpg";